import { PaymentType } from 'consts/consts';

export default {
    needAuth: 'Need to login',
    forbidWriteOff: 'Operations with a virtual account are forbid. Please contact your supervisor.',
    popup: {
        title: 'Choose a payment method',
        remaining: 'Access will be open until {{date}}, 23:59 — for another {{hours}} h. {{minutes}} m.',
        cancel: 'Cancel',
        [PaymentType.payByBankCard]: {
            priceInfo: 'Your card will be charged ₽\u00A0{{price}} for accessing the Active Carriers search — payment is made at the partner\'s website.\nYou can search for contractors immediately after payment.',
            confirm: 'Pay',
        },
        [PaymentType.payFromVirtualAccount]: {
            priceInfo: 'Your account will be debited {{price}}\u00A0ATISes for access to the Active Carriers search. You can search for contractors immediately after payment.',
            confirm: 'Pay',
        },
        [PaymentType.topUpVirtualAccount]: {
            priceInfo: 'You will be able to pay for the service after the ATISes have been deposited into your account.',
            confirm: 'Buy ATISes',
        },
        atises: {
            withBalance: {
                title: 'ATISes',
                description: 'from your account'
            },
            withoutBalance: {
                title: 'Buy ATISes',
                description: 'via bank transfer, cash, mobile payment'
            }
        },
        bankCard: 'Credit card',
    },
    accessPayed: 'Access has already been paid'
};
